import type { PropsWithChildren } from "react";
import { createContext } from "react";
import type { DataImportInfo } from "../../../api/types/dataImportTypes";

export interface Props {
  onDeleteImport: (imoport: DataImportInfo) => void;
  refreshData: () => void;
}

const ImportDataContext = createContext<Props | undefined>(undefined);

export const ImportDataContextProvider = ({ refreshData, onDeleteImport, children }: PropsWithChildren<Props>) => {
  return <ImportDataContext value={{ refreshData, onDeleteImport }}>{children}</ImportDataContext>;
};

export default ImportDataContext;
